<template>
    <div>
        <slot v-bind="{ query, handleInput, handleFocus, handleBlur, loading }" />

        <template v-if="isVisible">
            <div class="search-results container">
                <div class="search-results-content">
                    <div class="row">
                        <template v-for="result in results">
                            <div class="col-md-6 col-lg-4">
                                <div class="search-results-item search-results-item--products">
                                    <ProductResult :result="result" :key="result.id" />
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import axios from 'axios';
    import ProductResult from "./result/ProductResult.vue";
    import debounce from 'lodash/debounce';
    import { useClickOut } from "../../../use/click-out";

    export default {
        components: {
            ProductResult
        },
        props: {
            value: String,
            endpoint: String,
            minLength: {
                type: Number,
                default: 3,
            },
        },
        data() {
            return {
                query: this.value || '',
                results: null,
                visible: false,
                loading: false,
            }
        },
        computed: {
            isVisible() {
                return this.visible && !this.loading && this.results?.length > 0;
            },
        },
        methods: {
            search(query) {
                if(query.length < this.minLength) {
                    return;
                }
                this.loading = true;
                axios.post(this.endpoint, { q: query })
                    .then(response => {
                        this.results = response.data.data;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            handleInput(e) {
                this.query = e.target.value;
                this.visible = this.query.length >= this.minLength;
                this.search(this.query);
            },
            handleFocus() {
                this.visible = this.query.length >= this.minLength;
                this.$root.$emit('header::disable-sticky', true);
            },
            handleBlur() {
                setTimeout(()=>this.visible = false, 250);
                this.$root.$emit('header::disable-sticky', false);
            },
            handleClickOut() {
                this.$root.$emit('header::disable-sticky', false);
                this.visible = false;
            }
        },
        created() {
            this.search = debounce(this.search, 300);
        },
        mounted() {
            useClickOut(this, this.handleClickOut);
        },
    }
</script>
